var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResendInviteFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_150_164",
    "data-name": "Component 150 \\u2013 164",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7589",
    "data-name": "Group 7589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1178",
    "data-name": "Rectangle 1178",
    fill: "#ff3535",
    stroke: "#ff3535",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 34,
    rx: 17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2172",
    "data-name": "Path 2172",
    d: "M297.07,675.612v.015h9.092a.535.535,0,0,1,0,1.07h-9.627a.535.535,0,0,1-.535-.535v-9.627a.535.535,0,0,1,.535-.535h14.44a.535.535,0,0,1,.535.535v5.883a.535.535,0,0,1-1.07,0v-3.453l-3.285,2.555,1.486,1.224a.535.535,0,0,1-.68.826l-1.672-1.377-2.206,1.716a.535.535,0,0,1-.657,0l-2.206-1.716-4.151,3.418Zm0-1.386h0l3.285-2.706-3.285-2.555Zm6.685-1.416,6.685-5.2v-.541H297.07v.541Zm5.081,5.269.424-.424a.535.535,0,0,1,.756.756l-1.337,1.337a.535.535,0,0,1-.756,0l-1.337-1.337a.535.535,0,0,1,.756-.756l.424.424v-.848a3.209,3.209,0,1,1,3.209,3.209.535.535,0,1,1,0-1.07,2.139,2.139,0,1,0-2.139-2.139Z",
    transform: "translate(-287.593 -655.72)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendInviteFilled);
export default __webpack_public_path__ + "static/media/resend-invite-filled.40b2ce5b17aea767a4cb6670f9f8adbf.svg";
export { ForwardRef as ReactComponent };